import { render } from "./singlestake.vue?vue&type=template&id=77a7f28d&scoped=true&ts=true"
import script from "./singlestake.vue?vue&type=script&lang=ts"
export * from "./singlestake.vue?vue&type=script&lang=ts"

import "./singlestake.vue?vue&type=style&index=0&id=77a7f28d&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a7f28d"]])

export default __exports__